
import { useEffect, useState } from 'react';

import { Card, CardContent, Stack, Tabs, Tab, List, ListItem, ListItemAvatar, Avatar, ListItemText, Chip, Typography, CardHeader, InputBase, Paper, IconButton, Box, Button } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import DescriptionIcon from '@mui/icons-material/Description';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import AttachFileIcon from '@mui/icons-material/AttachFile';

import { PiCloudCheckFill } from 'react-icons/pi';
import { FaFileSignature } from "react-icons/fa";

import moment from 'moment';

import { TabsStyle, TabStyles } from '../../styles/TabsStyle';

import { AcuerdoProps } from '../../interfaces/tribunal/ExpedienteVirtualInterface';
import { NotificacionArchivoProps } from '../../interfaces/notificaciones/NotificacionesInterface';
import { DialogDocumento } from '../../dialogs/DialogDocumento';

interface params {
    acuerdos:   AcuerdoProps[];
}

export const ExpedienteVirtualDocumentos = ({ acuerdos }: params) => {

    const [tab, setTab] = useState( 0 );
    const [search, setSearch] = useState( '' );

    const [documentos, setDocumentos] = useState<AcuerdoProps[]>( [] );

    const [documento, setDocumento] = useState( '' );
    const [archivos, setArchivos] = useState<NotificacionArchivoProps[]>( [] );

    const [openDocumento, setOpenDocumento] = useState( false );

    const filtrarPorTexto = ( lista: AcuerdoProps[] ) => {

        const texto = search.trim().toLowerCase();

        if( texto === '' ) return lista;

        return lista.filter( (item) =>
            item.tipoAcuerdo?.toLowerCase().includes( texto )
            || item.numeroSeguimiento?.toLowerCase().includes( texto )
            || item.folioBuzonElectronico?.toLowerCase().includes( texto )
        );

    }

    const documentosFiltrados = filtrarPorTexto( documentos );

    useEffect(() => {

        setDocumentos( acuerdos );

    }, [ acuerdos ]);

    return (
        <Card>

            <CardHeader
                sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                subheader={<Typography variant='subtitle1' fontWeight={500} sx={{ color: 'white' }}> Documento(s) </Typography>}
                action={
                    <Paper component='div' sx={{ px: 1 }}>

                        <InputBase
                            sx={{ ml: 1, flex: 1, width: 180, '& input::placeholder': { fontSize: 14 } }}
                            placeholder='Buscar documento'
                            size='small'
                            value={ search }
                            onChange={ (e) => setSearch( e.target.value ) }
                        />

                        <IconButton
                            size='small'
                            onClick={ () => setSearch( '' ) }
                            sx={{ visibility: search ? 'visible' : 'hidden' }}
                        >
                            <ClearIcon fontSize='small' />
                        </IconButton>

                        <IconButton>
                            <SearchIcon />
                        </IconButton>

                    </Paper>
                }
            />

            <CardContent>

                <Stack spacing={2}>

                    <Stack direction='row' justifyContent='space-between'>

                        <Tabs
                            value={ tab }
                            onChange={ (_, value: number) => setTab( value ) }
                            variant='scrollable'
                            scrollButtons={ false }
                            sx={ TabsStyle }
                        >

                            <Tab label={ `Todos (${ filtrarPorTexto( acuerdos ).length })` } sx={ TabStyles } onClick={ () => setDocumentos( acuerdos ) } />
                            <Tab label={ `Acuerdos (${ filtrarPorTexto( acuerdos.filter( (e) => e.tipoAcuerdo.toLowerCase().includes( 'acuerdo' ) ) ).length })` } sx={ TabStyles } onClick={ () => setDocumentos( acuerdos.filter( (e) => e.tipoAcuerdo.toLowerCase().includes( 'acuerdo' ) ) ) } />
                            <Tab label={ `Audiencias (${ filtrarPorTexto( acuerdos.filter( (e) => e.tipoAcuerdo.toLowerCase().includes( 'audiencia' ) ) ).length })` } sx={ TabStyles } onClick={ () => setDocumentos( acuerdos.filter( (e) => e.tipoAcuerdo.toLowerCase().includes( 'audiencia' ) ) ) } />
                            <Tab label={ `Sentencias (${ filtrarPorTexto( acuerdos.filter( (e) => e.tipoAcuerdo.toLowerCase().includes( 'sentencia' ) ) ).length })` } sx={ TabStyles } onClick={ () => setDocumentos( acuerdos.filter( (e) => e.tipoAcuerdo.toLowerCase().includes( 'sentencia' ) ) ) } />
                            <Tab label={ `Amparos (${ filtrarPorTexto( acuerdos.filter( (e) => e.tipoAcuerdo.toLowerCase().includes( 'amparo' ) ) ).length })` } sx={ TabStyles } onClick={ () => setDocumentos( acuerdos.filter( (e) => e.tipoAcuerdo.toLowerCase().includes( 'amparo' ) ) ) } />
                            <Tab label={ `Oficios (${ filtrarPorTexto( acuerdos.filter( (e) => e.tipoAcuerdo.toLowerCase().includes( 'oficio' ) ) ).length })` } sx={ TabStyles } onClick={ () => setDocumentos( acuerdos.filter( (e) => e.tipoAcuerdo.toLowerCase().includes( 'oficio' ) ) ) } />

                        </Tabs>

                    </Stack>

                    <List sx={{ maxHeight: 450, overflowY: 'auto', pr: 0.5 }}>

                        {
                            documentosFiltrados.length === 0
                            &&
                                <Typography variant='caption' color='secondary' display='block' textAlign='center'>
                                    No se encontraron documentos.
                                </Typography>
                        }

                        {
                            documentosFiltrados.map( ({ tipoAcuerdo, fecha, numeroSeguimiento, folioBuzonElectronico, firmado, publicado, idListaAcuerdo, documento, archivos }, index) => (

                                <ListItem key={ index } divider>

                                    <Button
                                        fullWidth
                                        sx={{ textTransform: 'none', textAlign: 'left', color: 'inherit' }}
                                        onClick={ () => { setDocumento( documento ); setArchivos( archivos ?? [] ); setOpenDocumento( true ); } }
                                    >

                                        <ListItemAvatar>

                                            <Avatar sx={{ bgcolor: publicado ? (theme) => theme.palette.success.main : (theme) => theme.palette.primary.main }}>
                                                {
                                                    publicado
                                                    ?
                                                        <PiCloudCheckFill style={{ color: 'white', fontSize: 22 }} />
                                                    :
                                                        firmado 
                                                        ?
                                                            <FaFileSignature style={{ color: 'white', paddingLeft: 5, fontSize: 18 }} />
                                                        :
                                                            <DescriptionIcon sx={{ color: 'white' }} />
                                                }
                                            </Avatar>

                                        </ListItemAvatar>

                                        <ListItemText
                                            primary={<Typography variant='subtitle2'> { tipoAcuerdo } </Typography>}
                                            secondary={
                                                <Box mt={1}>

                                                    <Typography variant='body2' color='text.secondary' component='div'>
                                                        { moment( fecha ).format( 'DD-MM-YYYY HH:mm a' ) }
                                                    </Typography>

                                                    {
                                                        idListaAcuerdo !== 0
                                                        &&
                                                            <Typography variant='caption' color='text.secondary' component='div' mt={1}>
                                                                Publicado en lista de acuerdos <strong>(GLA-{ idListaAcuerdo })</strong>
                                                            </Typography>
                                                    }

                                                </Box>
                                            }
                                            slotProps={{
                                                secondary: {
                                                    component: 'div'
                                                }
                                            }}
                                        />

                                        {
                                            ( archivos && archivos.length !== 0 )
                                            &&
                                                <Chip
                                                    variant='filled'
                                                    size='small'
                                                    label={ <Typography variant='body2' color='secondary' fontWeight={ 'bold' }> +{ archivos.length } </Typography> }
                                                    icon={ <AttachFileIcon fontSize='small' /> }
                                                    sx={{ p: 2, mr: 2 }}
                                                />
                                        }

                                        {
                                            folioBuzonElectronico
                                            ?
                                                <Chip
                                                    variant='filled'
                                                    size='small'
                                                    label={ <Typography variant='subtitle2' color='secondary' sx={{ px: 1 }}> { folioBuzonElectronico } </Typography> }
                                                    icon={ <ForwardToInboxIcon fontSize='small' /> }
                                                    sx={{ p: 2, mr: 2 }}
                                                />
                                            :
                                                null
                                        }

                                        {
                                            numeroSeguimiento
                                            &&
                                                <Chip
                                                    variant='outlined'
                                                    label={
                                                        <Typography variant='body2' color='secondary' fontWeight={ 'bold' }>
                                                            { numeroSeguimiento }
                                                        </Typography>
                                                    }
                                                />
                                        }

                                    </Button>

                                </ListItem>

                            ))
                        }

                    </List>

                </Stack>

            </CardContent>

            <DialogDocumento
                documento={ documento }
                archivos={ archivos }
                openDialog={ openDocumento }
                handleCloseDialog={ () => setOpenDocumento( false ) }
            />

        </Card>
    );
}
